<ng-container *ngLet="legalPageState$ | async as currentlegalPageState">
	<app-page
		[showTopBanner]="false"
		[currentlegalPageState]="currentlegalPageState"
	>
		<div
			class="container position-relative"
			[class.oeg]="currentlegalPageState === LegalPageState.Oeg"
			[class.silvertec]="currentlegalPageState === LegalPageState.Silvertec"
		>
			<section class="section-padding">
				<div class="row mb-4">
					<div class="col col-xs-12 pt-2 pl-5">
						<div
							class="page-title"
							*ngIf="currentlegalPageState === LegalPageState.Terms"
							translate
						>
							General Terms and Conditions for using SeltronHome service
						</div>
						<div
							class="page-title"
							*ngIf="
								currentlegalPageState === LegalPageState.ClausiusBT ||
								currentlegalPageState === LegalPageState.Oeg ||
								currentlegalPageState === LegalPageState.Silvertec
							"
						>
							{{
								'General Terms and Conditions for using application'
									| translate : { appName: displayValues.appName }
							}}
						</div>
						<div
							class="page-title"
							*ngIf="currentlegalPageState === LegalPageState.TermsPartners"
							translate
						>
							General Terms and Conditions SeltronHome service for business
							users
						</div>
						<div
							class="page-title"
							*ngIf="currentlegalPageState === LegalPageState.Privacy"
							translate
						>
							Personal data protection statement SeltronHome
						</div>
					</div>
				</div>
				<div class="row" *ngIf="currentlegalPageState === LegalPageState.Terms">
					<div class="col col-12 col-md-4 menu">
						<ol>
							<li>
								<span (click)="scrollTo('general-endusers')" translate
									>General provisions</span
								>
							</li>
							<li>
								<span (click)="scrollTo('definitions-endusers')" translate
									>Definitions</span
								>
							</li>
							<li>
								<span (click)="scrollTo('service-endusers')" translate
									>SeltronHome service</span
								>
							</li>
							<li>
								<span (click)="scrollTo('clausius-endusers')" translate
									>Clausius application</span
								>
							</li>
							<li>
								<span (click)="scrollTo('gwd-endusers')" translate
									>GWD communication module</span
								>
							</li>
							<li>
								<span (click)="scrollTo('higherforce-endusers')" translate
									>Force majeure</span
								>
							</li>
							<li>
								<span (click)="scrollTo('support-endusers')" translate
									>User support</span
								>
							</li>
							<li>
								<span (click)="scrollTo('commitments-endusers')" translate
									>Provider's obligations</span
								>
							</li>
							<li>
								<span (click)="scrollTo('copyright-endusers')" translate
									>Copyright</span
								>
							</li>
							<li>
								<span (click)="scrollTo('finalprovisions-endusers')" translate
									>Final provisions</span
								>
							</li>
						</ol>
					</div>
					<div class="col col-12 col-md-8 legal-content">
						<div class="section" id="general-endusers">
							<div class="section-title">
								<div class="label">1.</div>
								<div class="text" translate>General provisions</div>
							</div>
							<div class="section-content">
								<div class="label">1.1.</div>
								<div class="text" translate>legal_terms_1_1</div>
							</div>
							<div class="section-content">
								<div class="label">1.2.</div>
								<div class="text">
									<span translate>legal_terms_1_2_1</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltronhome.com</a
									>
									<span translate>legal_terms_1_2_2</span>
								</div>
							</div>
						</div>
						<div class="section" id="definitions-endusers">
							<div class="section-title">
								<div class="label">2.</div>
								<div class="text" translate>Definitions</div>
							</div>
							<div class="section-content">
								<div class="label">2.1.</div>
								<div class="text">
									<b translate>Clausius application</b>
									<span class="ml-1" translate>legal_terms_2_1</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.2.</div>
								<div class="text">
									<b translate>Controller</b>
									<span class="ml-1" translate>legal_terms_2_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.3.</div>
								<div class="text">
									<b translate>legal_terms_2_3_1</b>
									<span class="ml-1" translate>legal_terms_2_3_2</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_PAGE"
										>www.seltron.si</a
									>.
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.4.</div>
								<div class="text">
									<b translate>legal_terms_2_4_1</b>
									<span class="ml-1" translate>legal_terms_2_4_2</span>
									<ng-container *ngIf="languageName === 'sl'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
											>www.seltronhome.com</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.5.</div>
								<div class="text">
									<b translate>legal_terms_2_5_1</b>
									<ng-container *ngIf="languageName === 'en'">
										<span class="ml-1" translate>legal_terms_2_5_2</span>
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
											>www.seltronhome.com</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.6.</div>
								<div class="text">
									<b translate>legal_terms_2_6_1</b>
									<span class="ml-1" translate>legal_terms_2_6_2</span>
									<ng-container *ngIf="languageName === 'sl'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
											>www.seltronhome.com</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.7.</div>
								<div class="text">
									<b translate>legal_terms_2_7_1</b>
									<span class="ml-1" translate>legal_terms_2_7_2</span>
									<ng-container *ngIf="languageName === 'en'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
											>www.seltronhome.com</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.8.</div>
								<div class="text">
									<b translate>legal_terms_2_8_1</b>
									<span class="ml-1" translate>legal_terms_2_8_2</span>
									<ng-container *ngIf="languageName === 'en'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_PAGE"
											>www.seltron.si</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.9.</div>
								<div class="text">
									<b translate>legal_terms_2_9_1</b>
									<span class="ml-1" translate>legal_terms_2_9_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.10.</div>
								<div class="text">
									<b translate>legal_terms_2_10_1</b>
									<span class="ml-1" translate>legal_terms_2_10_2</span>
									<ng-container *ngIf="languageName === 'sl'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_PAGE"
											>www.seltron.si</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.11.</div>
								<div class="text">
									<b translate>legal_terms_2_11_1</b>
									<span class="ml-1" translate>legal_terms_2_11_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.12.</div>
								<div class="text">
									<b translate>legal_terms_2_12_1</b>
									<span class="ml-1" translate>legal_terms_2_12_2</span>
								</div>
							</div>
						</div>
						<div class="section" id="service-endusers">
							<div class="section-title">
								<div class="label">3.</div>
								<div class="text" translate>SeltronHome service</div>
							</div>
							<div class="section-content">
								<div class="label">3.1.</div>
								<div class="text" translate>legal_terms_3_1</div>
							</div>
							<div class="section-content">
								<div class="label">3.2.</div>
								<div class="text" translate>legal_terms_3_2</div>
							</div>
							<div class="section-content">
								<div class="label">3.3.</div>
								<div class="text" translate>legal_terms_3_3</div>
							</div>
						</div>
						<div class="section" id="clausius-endusers">
							<div class="section-title">
								<div class="label">4.</div>
								<div class="text" translate>Clausius application</div>
							</div>
							<div class="section-subtitle">
								<div class="label">4.1.</div>
								<div class="text" translate>Use of Clausius application</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.1.</div>
								<div class="text" translate>legal_terms_4_1_1</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.2.</div>
								<div class="text" translate>legal_terms_4_1_2</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.3.</div>
								<div class="text" translate>legal_terms_4_1_3</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.4.</div>
								<div class="text" translate>legal_terms_4_1_4</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.5.</div>
								<div class="text" translate>legal_terms_4_1_5</div>
							</div>
							<div class="section-subtitle">
								<div class="label">4.2.</div>
								<div class="text" translate>
									Managing the shared SeltronHome environment
								</div>
							</div>
							<div class="section-content">
								<div class="label">4.2.1.</div>
								<div class="text" translate>legal_terms_4_2_1</div>
							</div>
							<div class="section-content">
								<div class="label">4.2.2.</div>
								<div class="text" translate>legal_terms_4_2_2</div>
							</div>
							<div class="section-content">
								<div class="label">4.2.3.</div>
								<div class="text" translate>legal_terms_4_2_3</div>
							</div>
							<div class="section-subtitle">
								<div class="label">4.3.</div>
								<div class="text" translate>
									Misuse of Clausius application and santions
								</div>
							</div>
							<div class="section-content">
								<div class="label">4.3.1.</div>
								<div class="text" translate>legal_terms_4_3_1</div>
							</div>
							<div class="section-content">
								<div class="label">4.3.2.</div>
								<div class="text" translate>legal_terms_4_3_2</div>
							</div>
							<div class="section-content">
								<div class="label">4.3.3.</div>
								<div class="text" translate>legal_terms_4_3_3</div>
							</div>
							<div class="section-subtitle">
								<div class="label">4.4.</div>
								<div class="text" translate>Removing user account</div>
							</div>
							<div class="section-content">
								<div class="label">4.4.1.</div>
								<div class="text" translate>legal_terms_4_4_1</div>
							</div>
							<div class="section-content">
								<div class="label">4.4.2.</div>
								<div class="text" translate>legal_terms_4_4_2</div>
							</div>
							<div class="section-content">
								<div class="label">4.4.3.</div>
								<div class="text">
									<span translate>legal_terms_4_4_3_1</span>
									<a
										class="d-inline ml-1"
										[externalRedirect]="EXTERNAL_PATH.MAIL_TO_INFO_SELTRON_HOME"
										>info@seltronhome.com</a
									>
									<span translate>legal_terms_4_4_3_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">4.4.4.</div>
								<div class="text" translate>legal_terms_4_4_4</div>
							</div>
							<div class="section-content">
								<div class="label">4.4.5.</div>
								<div class="text" translate>legal_terms_4_4_5</div>
							</div>
							<div class="section-content">
								<div class="label">4.4.6.</div>
								<div class="text" translate>legal_terms_4_4_6</div>
							</div>
							<div class="section-content">
								<div class="label">4.4.7.</div>
								<div class="text" translate>legal_terms_4_4_7</div>
							</div>
							<div class="section-content">
								<div class="label">4.4.8.</div>
								<div class="text" translate>legal_terms_4_4_8</div>
							</div>
							<div class="section-content">
								<div class="label">4.4.9.</div>
								<div class="text" translate>legal_terms_4_4_9</div>
							</div>
							<div class="section-content">
								<div class="label">4.4.10.</div>
								<div class="text" translate>legal_terms_4_4_10</div>
							</div>
							<div class="section-subtitle">
								<div class="label">4.5.</div>
								<div class="text" translate>Payments</div>
							</div>
							<div class="section-content">
								<div class="label">4.5.1.</div>
								<div class="text" translate>legal_terms_4_5_1</div>
							</div>
							<div class="section-content">
								<div class="label">4.5.2.</div>
								<div class="text" translate>legal_terms_4_5_2</div>
							</div>
							<div class="section-content">
								<div class="label">4.5.3.</div>
								<div class="text" translate>legal_terms_4_5_3</div>
							</div>
						</div>
						<div class="section" id="gwd-endusers">
							<div class="section-title">
								<div class="label">5.</div>
								<div class="text" translate>GWD communication module</div>
							</div>
							<div class="section-subtitle">
								<div class="label">5.1.</div>
								<div class="text" translate>Purchase, set-up and use</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.1.</div>
								<div class="text">
									<span translate>legal_terms_5_1_1_1</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_PAGE"
										>www.seltron.si</a
									>
									<span translate>legal_terms_5_1_1_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.2.</div>
								<div class="text" translate>legal_terms_5_1_2</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.3.</div>
								<div class="text">
									<span translate>legal_terms_5_1_3</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltronhome.com</a
									>.
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.4.</div>
								<div class="text" translate>legal_terms_5_1_4</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.5.</div>
								<div class="text" translate>legal_terms_5_1_5</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.6.</div>
								<div class="text" translate>legal_terms_5_1_6</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.7.</div>
								<div class="text" translate>legal_terms_5_1_7</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.8.</div>
								<div class="text" translate>legal_terms_5_1_8</div>
							</div>
							<div class="section-subtitle">
								<div class="label">5.2.</div>
								<div class="text" translate>Warranty</div>
							</div>
							<div class="section-content">
								<div class="label">5.2.1.</div>
								<div class="text" translate>legal_terms_5_2_1</div>
							</div>
						</div>
						<div class="section" id="higherforce-endusers">
							<div class="section-title">
								<div class="label">6.</div>
								<div class="text" translate>Force majeure</div>
							</div>
							<div class="section-content">
								<div class="label">6.1.</div>
								<div class="text" translate>legal_terms_6_1</div>
							</div>
						</div>
						<div class="section" id="support-endusers">
							<div class="section-title">
								<div class="label">7.</div>
								<div class="text" translate>User support</div>
							</div>
							<div class="section-subtitle">
								<div class="label">7.1.</div>
								<div class="text" translate>Tehnical support</div>
							</div>
							<div class="section-content">
								<div class="label">7.1.1.</div>
								<div class="text" translate>legal_terms_7_1_1</div>
							</div>
							<div class="section-content">
								<div class="label">7.1.2.</div>
								<div class="text">
									<span translate>legal_terms_7_1_2_1</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltronhome.com</a
									>
									<span class="ml-1" translate>legal_terms_7_1_2_2</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_PAGE"
										>www.seltron.si</a
									>.
								</div>
							</div>
							<div class="section-content">
								<div class="label">7.1.3.</div>
								<div class="text" translate>legal_terms_7_1_3</div>
							</div>
							<div class="section-content">
								<div class="label">7.1.4.</div>
								<div class="text" translate>
									Working time of tehnical support
								</div>
							</div>
							<div class="section-content">
								<div class="label">7.1.5.</div>
								<div class="text" translate>legal_terms_7_1_5</div>
							</div>
							<div class="section-content">
								<div class="label">7.1.6.</div>
								<div class="text">
									<span translate>legal_terms_7_1_6_1</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltronhome.com</a
									>
									<span class="ml-1" translate>legal_terms_7_1_6_2</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.MAIL_TO_INFO_SELTRON_HOME"
										>info@seltronhome.com</a
									>
									<span class="ml-1" translate>legal_terms_7_1_6_3</span>
									<a
										class="ml-1"
										[externalRedirect]="
											EXTERNAL_PATH.MAIL_TO_TECHNICAL_SUPPORT_SELTON_HOME
										"
										>tehnicna.podpora@seltron.si</a
									>.
								</div>
							</div>
							<div class="section-content">
								<div class="label">7.1.7.</div>
								<div class="text" translate>legal_terms_7_1_7</div>
							</div>
							<div class="section-content">
								<div class="label">7.1.8.</div>
								<div class="text" translate>legal_terms_7_1_8</div>
							</div>
							<div class="section-subtitle">
								<div class="label">7.2.</div>
								<div class="text" translate>Kelvin application</div>
							</div>
							<div class="section-content">
								<div class="label">7.2.1.</div>
								<div class="text" translate>legal_terms_7_2_1</div>
							</div>
							<div class="section-content">
								<div class="label">7.2.2.</div>
								<div class="text" translate>legal_terms_7_2_2</div>
							</div>
							<div class="section-content">
								<div class="label">7.2.3.</div>
								<div class="text" translate>legal_terms_7_2_3</div>
							</div>
							<div class="section-content">
								<div class="label">7.2.4.</div>
								<div class="text" translate>legal_terms_7_2_4</div>
							</div>
							<div class="section-content">
								<div class="label">7.2.5.</div>
								<div class="text" translate>legal_terms_7_2_5</div>
							</div>
							<div class="section-content">
								<div class="label">7.2.6.</div>
								<div class="text" translate>legal_terms_7_2_6</div>
							</div>
							<div class="section-content">
								<div class="label">7.2.7.</div>
								<div class="text" translate>legal_terms_7_2_7</div>
							</div>
						</div>
						<div class="section" id="commitments-endusers">
							<div class="section-title">
								<div class="label">8.</div>
								<div class="text" translate>Provider's obligations</div>
							</div>
							<div class="section-content">
								<div class="label">8.1.</div>
								<div class="text" translate>legal_terms_8_1</div>
							</div>
							<div class="section-content">
								<div class="label">8.2.</div>
								<div class="text" translate>legal_terms_8_2</div>
							</div>
							<div class="section-content">
								<div class="label">8.3.</div>
								<div class="text" translate>legal_terms_8_3</div>
							</div>
							<div class="section-content">
								<div class="label">8.4.</div>
								<div class="text">
									<span translate>legal_terms_8_4_1</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltronhome.com</a
									>
									<span class="ml-1" translate>legal_terms_8_4_2</span>
								</div>
							</div>
						</div>
						<div class="section" id="copyright-endusers">
							<div class="section-title">
								<div class="label">9.</div>
								<div class="text" translate>Copyright</div>
							</div>
							<div class="section-content">
								<div class="label">9.1.</div>
								<div class="text" translate>legal_terms_9_1</div>
							</div>
							<div class="section-content">
								<div class="label">9.2.</div>
								<div class="text" translate>legal_terms_9_2</div>
							</div>
						</div>
						<div class="section" id="finalprovisions-endusers">
							<div class="section-title">
								<div class="label">10.</div>
								<div class="text" translate>Final provisions</div>
							</div>
							<div class="section-content">
								<div class="label">10.1.</div>
								<div class="text" translate>legal_terms_10_1</div>
							</div>
							<div class="section-content">
								<div class="label">10.2.</div>
								<div class="text" translate>legal_terms_10_2</div>
							</div>
							<div class="section-content">
								<div class="label">10.3.</div>
								<div class="text" translate>legal_terms_10_3</div>
							</div>
							<div class="section-content">
								<div class="label">10.4.</div>
								<div class="text" translate>legal_terms_10_4</div>
							</div>
							<div class="section-content">
								<div class="label">10.5.</div>
								<div class="text" translate>legal_terms_10_5</div>
							</div>
							<div class="section-content">
								<div class="label">10.6.</div>
								<div class="text">
									<span translate>legal_terms_10_6</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltronhome.com</a
									>.
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="row"
					*ngIf="currentlegalPageState === LegalPageState.TermsPartners"
				>
					<div class="col col-12 col-md-4 menu">
						<ol>
							<li>
								<span (click)="scrollTo('general-partners')" translate
									>General provisions</span
								>
							</li>
							<li>
								<span (click)="scrollTo('definitions-partners')" translate
									>Definitions</span
								>
							</li>
							<li>
								<span
									(click)="scrollTo('seltronhomeservice-partners')"
									translate
									>SeltronHome service</span
								>
							</li>
							<li>
								<span (click)="scrollTo('kelvin-partners')" translate
									>Kelvin application</span
								>
							</li>
							<li>
								<span (click)="scrollTo('gwd-partners')" translate
									>GWD communication module</span
								>
							</li>
							<li>
								<span (click)="scrollTo('warranty-partners')" translate
									>Warranty</span
								>
							</li>
							<li>
								<span (click)="scrollTo('higherforce-partners')" translate
									>Force majeure</span
								>
							</li>
							<li>
								<span (click)="scrollTo('support-partners')" translate
									>Technical support by the provider</span
								>
							</li>
							<li>
								<span (click)="scrollTo('customers-partners')" translate
									>Relationship between the business user and its
									customers</span
								>
							</li>
							<li>
								<span (click)="scrollTo('commitments-partners')" translate
									>Provider’s obligations</span
								>
							</li>
							<li>
								<span (click)="scrollTo('copyright-partners')" translate
									>Copyright</span
								>
							</li>
							<li>
								<span (click)="scrollTo('finaldefinitions-partners')" translate
									>Final provisions</span
								>
							</li>
						</ol>
					</div>
					<div class="col col-12 col-md-8 legal-content">
						<div class="section" id="general-partners">
							<div class="section-title">
								<div class="label">1.</div>
								<div class="text" translate>General Provisions</div>
							</div>
							<div class="section-content">
								<div class="label">1.1.</div>
								<div class="text" translate>legal_terms_partners_1_1</div>
							</div>
							<div class="section-content">
								<div class="label">1.2.</div>
								<div class="text" translate>legal_terms_partners_1_2</div>
							</div>
						</div>
						<div class="section" id="definitions-partners">
							<div class="section-title">
								<div class="label">2.</div>
								<div class="text" translate>Definitions</div>
							</div>
							<div class="section-content">
								<div class="label">2.1.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_1_1</b>
									<span class="ml-1" translate>legal_terms_partners_2_1_2</span>
									<ng-container *ngIf="languageName === 'sl'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_PAGE"
											>www.seltron.si</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.2.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_2_1</b>
									<span class="ml-1" translate>legal_terms_partners_2_2_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.3.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_3_1</b>
									<span class="ml-1" translate>legal_terms_partners_2_3_2</span>
									<ng-container *ngIf="languageName === 'sl'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
											>www.seltron.com</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.4.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_4_1</b>
									<span class="ml-1" translate>legal_terms_partners_2_4_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.5.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_5_1</b>
									<span class="ml-1" translate>legal_terms_partners_2_5_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.6.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_6_1</b>
									<span class="ml-1" translate>legal_terms_partners_2_6_2</span>
									<ng-container *ngIf="languageName === 'en'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
											>www.seltron.com</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.7.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_7_1</b>
									<span class="ml-1" translate>legal_terms_partners_2_7_2</span>
									<ng-container *ngIf="languageName !== 'en'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
											>www.seltron.com</a
										>.
									</ng-container>
									<ng-container *ngIf="languageName === 'en'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_PAGE"
											>www.seltron.si</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.8.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_8_1</b>
									<span class="ml-1" translate>legal_terms_partners_2_8_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.9.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_9_1</b>
									<span class="ml-1" translate>legal_terms_partners_2_9_2</span>
									<ng-container *ngIf="languageName === 'en'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
											>www.seltron.com</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.10.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_10_1</b>
									<span class="ml-1" translate
										>legal_terms_partners_2_10_2</span
									>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.11.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_11_1</b>
									<span class="ml-1" translate
										>legal_terms_partners_2_11_2</span
									>
									<ng-container *ngIf="languageName !== 'sl'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
											>www.seltron.com</a
										>.
									</ng-container>
									<ng-container *ngIf="languageName === 'sl'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_PAGE"
											>www.seltron.si</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.12.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_12_1</b>
									<span class="ml-1" translate
										>legal_terms_partners_2_12_2</span
									>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_PAGE"
										>www.seltron.si</a
									>.
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.13.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_13_1</b>
									<span class="ml-1" translate
										>legal_terms_partners_2_13_2</span
									>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.14.</div>
								<div class="text">
									<b translate>legal_terms_partners_2_14_1</b>
									<span class="ml-1" translate
										>legal_terms_partners_2_14_2</span
									>
								</div>
							</div>
						</div>
						<div class="section" id="seltronhomeservice-partners">
							<div class="section-title">
								<div class="label">3.</div>
								<div class="text" translate>SeltronHome service</div>
							</div>
							<div class="section-content">
								<div class="label">3.1.</div>
								<div class="text" translate>legal_terms_partners_3_1</div>
							</div>
							<div class="section-content">
								<div class="label">3.2.</div>
								<div class="text" translate>legal_terms_partners_3_2</div>
							</div>
							<div class="section-content">
								<div class="label">3.3.</div>
								<div class="text" translate>legal_terms_partners_3_3</div>
							</div>
							<div class="section-content">
								<div class="label">3.4.</div>
								<div class="text" translate>legal_terms_partners_3_4</div>
							</div>
							<div class="section-content">
								<div class="label">3.5.</div>
								<div class="text" translate>legal_terms_partners_3_5</div>
							</div>
						</div>
						<div class="section" id="kelvin-partners">
							<div class="section-title">
								<div class="label">4.</div>
								<div class="text" translate>Kelvin application</div>
							</div>
							<div class="section-subtitle">
								<div class="label">4.1.</div>
								<div class="text" translate>Using the Kelvin application</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.1.</div>
								<div class="text">
									<span translate>legal_terms_partners_4_1_1</span>
									<ul>
										<li translate>Servicing of heating systems,</li>
										<li translate>
											Electrical installations of heating systems,
										</li>
										<li translate>Operation and maintenance of boilers.</li>
									</ul>
								</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.2.</div>
								<div class="text" translate>legal_terms_partners_4_1_2</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.3.</div>
								<div class="text" translate>legal_terms_partners_4_1_3</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.4.</div>
								<div class="text" translate>legal_terms_partners_4_1_4</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.5.</div>
								<div class="text" translate>legal_terms_partners_4_1_5</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.6.</div>
								<div class="text" translate>legal_terms_partners_4_1_6</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.7.</div>
								<div class="text" translate>legal_terms_partners_4_1_7</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.8.</div>
								<div class="text" translate>legal_terms_partners_4_1_8</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.9.</div>
								<div class="text">
									<span translate>legal_terms_partners_4_1_9</span>
									<ul>
										<li translate>Google Inc. (authentication with Auth0),</li>
										<li translate>Facebook Inc. (authentication),</li>
										<li translate>Auth0 Inc. (authentication),</li>
										<li translate>
											Microsoft Corp. (data analytics, server and data
											infrastructure, helpdesk plugin),
										</li>
										<li translate>
											OpenWeatherMap, Inc. (weather forecast for the building
											location entry).
										</li>
									</ul>
								</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.10.</div>
								<div class="text" translate>legal_terms_partners_4_1_10</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.11.</div>
								<div class="text">
									<span translate>legal_terms_partners_4_1_11</span>
									<a
										class="d-inline ml-1"
										[externalRedirect]="EXTERNAL_PATH.MAIL_TO_INFO_SELTRON_HOME"
										>info@seltronhome.com</a
									>.
								</div>
							</div>
							<div class="section-subtitle">
								<div class="label">4.2.</div>
								<div class="text" translate>
									Misuse of the Kelvin application and sanctions
								</div>
							</div>
							<div class="section-content">
								<div class="label">4.2.1.</div>
								<div class="text" translate>legal_terms_partners_4_2_1</div>
							</div>
							<div class="section-content">
								<div class="label">4.2.2.</div>
								<div class="text" translate>legal_terms_partners_4_2_2</div>
							</div>
							<div class="section-subtitle">
								<div class="label">4.3.</div>
								<div class="text" translate>
									Removing user accounts and restricting the use of user
									accounts
								</div>
							</div>
							<div class="section-content">
								<div class="label">4.3.1.</div>
								<div class="text" translate>legal_terms_partners_4_3_1</div>
							</div>
							<div class="section-content">
								<div class="label">4.3.2.</div>
								<div class="text" translate>legal_terms_partners_4_3_2</div>
							</div>
							<div class="section-content">
								<div class="label">4.3.3.</div>
								<div class="text" translate>legal_terms_partners_4_3_3</div>
							</div>
							<div class="section-content">
								<div class="label">4.3.4.</div>
								<div class="text" translate>legal_terms_partners_4_3_4</div>
							</div>
							<div class="section-content">
								<div class="label">4.3.5.</div>
								<div class="text" translate>legal_terms_partners_4_3_5</div>
							</div>
							<div class="section-content">
								<div class="label">4.3.6.</div>
								<div class="text" translate>legal_terms_partners_4_3_6</div>
							</div>
							<div class="section-subtitle">
								<div class="label">4.4.</div>
								<div class="text" translate>Payments</div>
							</div>
							<div class="section-content">
								<div class="label">4.4.1.</div>
								<div class="text" translate>legal_terms_partners_4_4_1</div>
							</div>
							<div class="section-content">
								<div class="label">4.4.2.</div>
								<div class="text" translate>legal_terms_partners_4_4_2</div>
							</div>
							<div class="section-content">
								<div class="label">4.4.3.</div>
								<div class="text" translate>legal_terms_partners_4_4_3</div>
							</div>
						</div>
						<div class="section" id="gwd-partners">
							<div class="section-title">
								<div class="label">5.</div>
								<div class="text" translate>GWD communication module</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.</div>
								<div class="text">
									<span translate>legal_terms_partners_5_1_1</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_PAGE"
										>www.seltron.si</a
									>.
									<span class="ml-1" translate>legal_terms_partners_5_1_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.2.</div>
								<div class="text" translate>legal_terms_partners_5_2</div>
							</div>
							<div class="section-content">
								<div class="label">5.3.</div>
								<div class="text">
									<span translate>legal_terms_partners_5_3_1</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltron.com</a
									>.
									<span class="ml-1" translate>legal_terms_partners_5_3_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.4.</div>
								<div class="text" translate>legal_terms_partners_5_4</div>
							</div>
							<div class="section-content">
								<div class="label">5.5.</div>
								<div class="text" translate>legal_terms_partners_5_5</div>
							</div>
							<div class="section-content">
								<div class="label">5.6.</div>
								<div class="text" translate>legal_terms_partners_5_6</div>
							</div>
							<div class="section-content">
								<div class="label">5.7.</div>
								<div class="text" translate>legal_terms_partners_5_7</div>
							</div>
							<div class="section-content">
								<div class="label">5.8.</div>
								<div class="text" translate>legal_terms_partners_5_8</div>
							</div>
						</div>
						<div class="section" id="warranty-partners">
							<div class="section-title">
								<div class="label">6.</div>
								<div class="text" translate>Warranty</div>
							</div>
							<div class="section-content">
								<div class="label">6.1.</div>
								<div class="text" translate>legal_terms_partners_6_1</div>
							</div>
						</div>
						<div class="section" id="higherforce-partners">
							<div class="section-title">
								<div class="label">7.</div>
								<div class="text" translate>Force majeure</div>
							</div>
							<div class="section-content">
								<div class="label">7.1.</div>
								<div class="text" translate>legal_terms_partners_7_1</div>
							</div>
						</div>
						<div class="section" id="support-partners">
							<div class="section-title">
								<div class="label">8.</div>
								<div class="text" translate>
									Technical support by the provider
								</div>
							</div>
							<div class="section-content">
								<div class="label">8.1.</div>
								<div class="text" translate>legal_terms_partners_8_1</div>
							</div>
							<div class="section-content">
								<div class="label">8.2.</div>
								<div class="text">
									<span translate>legal_terms_partners_8_2_1</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltronhome.com</a
									>
									<span class="ml-1" translate>legal_terms_partners_8_2_2</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.MAIL_TO_INFO_SELTRON_HOME"
										>info@seltronhome.com</a
									>
									<span class="ml-1" translate>legal_terms_partners_8_2_3</span>
									<a
										class="ml-1"
										[externalRedirect]="
											EXTERNAL_PATH.MAIL_TO_TECHNICAL_SUPPORT_SELTON_HOME
										"
										>tehnicna.podpora@seltron.si</a
									>.
								</div>
							</div>
							<div class="section-content">
								<div class="label">8.3.</div>
								<div class="text" translate>legal_terms_partners_8_3</div>
							</div>
						</div>
						<div class="section" id="customers-partners">
							<div class="section-title">
								<div class="label">9.</div>
								<div class="text" translate>
									Relationship between the business user and its customers
								</div>
							</div>
							<div class="section-subtitle">
								<div class="label">9.1.</div>
								<div class="text" translate>
									Rights and obligations of the business user
								</div>
							</div>
							<div class="section-content">
								<div class="label">9.1.1.</div>
								<div class="text" translate>legal_terms_partners_9_1_1</div>
							</div>
							<div class="section-content">
								<div class="label">9.1.2.</div>
								<div class="text" translate>legal_terms_partners_9_1_2</div>
							</div>
							<div class="section-content">
								<div class="label">9.1.3.</div>
								<div class="text" translate>legal_terms_partners_9_1_3</div>
							</div>
							<div class="section-content">
								<div class="label">9.1.4.</div>
								<div class="text" translate>legal_terms_partners_9_1_4</div>
							</div>
							<div class="section-content">
								<div class="label">9.1.5.</div>
								<div class="text" translate>legal_terms_partners_9_1_5</div>
							</div>
							<div class="section-subtitle">
								<div class="label">9.2.</div>
								<div class="text" translate>Technical connection</div>
							</div>
							<div class="section-content">
								<div class="label">9.2.1.</div>
								<div class="text">
									<span translate>legal_terms_partners_9_2_1</span>
									<ul>
										<li translate>legal_terms_partners_9_2_1_1</li>
										<li translate>legal_terms_partners_9_2_1_2</li>
									</ul>
								</div>
							</div>
							<div class="section-subtitle">
								<div class="label">9.3.</div>
								<div class="text" translate>Access to heating systems</div>
							</div>
							<div class="section-content">
								<div class="label">9.3.1.</div>
								<div class="text" translate>legal_terms_partners_9_3_1</div>
							</div>
							<div class="section-content">
								<div class="label">9.3.2.</div>
								<div class="text" translate>legal_terms_partners_9_3_2</div>
							</div>
							<div class="section-subtitle">
								<div class="label">9.4.</div>
								<div class="text" translate>Data protection</div>
							</div>
							<div class="section-content">
								<div class="label">9.4.1.</div>
								<div class="text" translate>legal_terms_partners_9_4_1</div>
							</div>
							<div class="section-content">
								<div class="label">9.4.2.</div>
								<div class="text" translate>legal_terms_partners_9_4_2</div>
							</div>
							<div class="section-content">
								<div class="label">9.4.3.</div>
								<div class="text" translate>legal_terms_partners_9_4_3</div>
							</div>
							<div class="section-content">
								<div class="label">9.4.4.</div>
								<div class="text">
									<span translate>legal_terms_partners_9_4_4</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltronhome.com</a
									>.
								</div>
							</div>
							<div class="section-content">
								<div class="label">9.4.5.</div>
								<div class="text" translate>legal_terms_partners_9_4_5</div>
							</div>
							<div class="section-content">
								<div class="label">9.4.6.</div>
								<div class="text" translate>legal_terms_partners_9_4_6</div>
							</div>
							<div class="section-subtitle">
								<div class="label">9.5.</div>
								<div class="text" translate>Disputes with customers</div>
							</div>
							<div class="section-content">
								<div class="label">9.5.1.</div>
								<div class="text" translate>legal_terms_partners_9_5_1</div>
							</div>
							<div class="section-content">
								<div class="label">9.5.2.</div>
								<div class="text" translate>legal_terms_partners_9_5_2</div>
							</div>
							<div class="section-content">
								<div class="label">9.5.3.</div>
								<div class="text" translate>legal_terms_partners_9_5_3</div>
							</div>
						</div>
						<div class="section" id="commitments-partners">
							<div class="section-title">
								<div class="label">10.</div>
								<div class="text" translate>Provider’s obligations</div>
							</div>
							<div class="section-content">
								<div class="label">10.1.</div>
								<div class="text" translate>legal_terms_partners_10_1</div>
							</div>
							<div class="section-content">
								<div class="label">10.2.</div>
								<div class="text" translate>legal_terms_partners_10_2</div>
							</div>
							<div class="section-content">
								<div class="label">10.3.</div>
								<div class="text" translate>legal_terms_partners_10_3</div>
							</div>
							<div class="section-content">
								<div class="label">10.4.</div>
								<div class="text" translate>legal_terms_partners_10_4</div>
							</div>
						</div>
						<div class="section" id="copyright-partners">
							<div class="section-title">
								<div class="label">11.</div>
								<div class="text" translate>Copyright</div>
							</div>
							<div class="section-content">
								<div class="label">11.1.</div>
								<div class="text" translate>legal_terms_partners_11_1</div>
							</div>
							<div class="section-content">
								<div class="label">11.2.</div>
								<div class="text" translate>legal_terms_partners_11_2</div>
							</div>
							<div class="section-content">
								<div class="label">11.3.</div>
								<div class="text" translate>legal_terms_partners_11_3</div>
							</div>
						</div>
						<div class="section" id="finaldefinitions-partners">
							<div class="section-title">
								<div class="label">12.</div>
								<div class="text" translate>Final provisions</div>
							</div>
							<div class="section-content">
								<div class="label">12.1.</div>
								<div class="text" translate>legal_terms_partners_12_1</div>
							</div>
							<div class="section-content">
								<div class="label">12.2.</div>
								<div class="text" translate>legal_terms_partners_12_2</div>
							</div>
							<div class="section-content">
								<div class="label">12.3.</div>
								<div class="text" translate>legal_terms_partners_12_3</div>
							</div>
							<div class="section-content">
								<div class="label">12.4.</div>
								<div class="text" translate>legal_terms_partners_12_4</div>
							</div>
							<div class="section-content">
								<div class="label">12.5.</div>
								<div class="text" translate>legal_terms_partners_12_5</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="row"
					*ngIf="
						currentlegalPageState === LegalPageState.ClausiusBT ||
						currentlegalPageState === LegalPageState.Oeg ||
						currentlegalPageState === LegalPageState.Silvertec
					"
				>
					<div class="col col-12 col-md-4 menu">
						<ol>
							<li>
								<span (click)="scrollTo('general-endusers')" translate
									>General provisions</span
								>
							</li>
							<li>
								<span (click)="scrollTo('definitions-endusers')" translate
									>Definitions</span
								>
							</li>
							<li>
								<span (click)="scrollTo('about-application')">{{
									'App' | translate : { appName: displayValues.appName }
								}}</span>
							</li>
							<li>
								<span (click)="scrollTo('application-support')" translate
									>Force majeure</span
								>
							</li>
							<li>
								<span (click)="scrollTo('support-endusers')" translate
									>User support</span
								>
							</li>
							<li>
								<span (click)="scrollTo('providers-obligations')" translate
									>Provider's obligations</span
								>
							</li>
							<li>
								<span (click)="scrollTo('copyright-endusers')" translate
									>Copyright</span
								>
							</li>
							<li>
								<span (click)="scrollTo('finalprovisions-endusers')" translate
									>Final provisions</span
								>
							</li>
						</ol>
					</div>
					<div class="col col-12 col-md-8 legal-content">
						<div class="section" id="general-endusers">
							<div class="section-title">
								<div class="label">1.</div>
								<div class="text" translate>General provisions</div>
							</div>
							<div class="section-content">
								<div class="label">1.1.</div>
								<div class="text">
									{{
										'application_legal_terms_1_1'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">1.2.</div>
								<div class="text">
									{{
										'application_legal_terms_1_2'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">1.3.</div>
								<div class="text">
									<b translate>application_legal_terms_1_3</b>
									<span>
										{{
											'application_legal_terms_1_3_1'
												| translate : { appName: displayValues.appName }
										}}
									</span>
								</div>
							</div>
						</div>
						<div class="section" id="definitions-endusers">
							<div class="section-title">
								<div class="label">2.</div>
								<div class="text" translate>Definitions</div>
							</div>
							<div class="section-content">
								<div class="label">2.1.</div>
								<div class="text">
									<b>
										{{
											'App' | translate : { appName: displayValues.appName }
										}}</b
									>
									<span class="ml-1" translate
										>application_legal_terms_2_1</span
									>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.2.</div>
								<div class="text">
									<b translate>Provider</b>
									<span class="ml-1">{{
										'application_legal_terms_2_2'
											| translate : { appName: displayValues.appName }
									}}</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.3.</div>
								<div class="text">
									<b translate>Customer</b>
									<span class="ml-1">
										{{
											'application_legal_terms_2_3'
												| translate : { appName: displayValues.appName }
										}}
									</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.4.</div>
								<div class="text">
									<b translate>SELTRON bluetooth device</b>
									<span class="ml-1">
										{{
											'application_legal_terms_2_4'
												| translate : { appName: displayValues.appName }
										}}
									</span>
								</div>
							</div>
						</div>
						<div class="section" id="about-application">
							<div class="section-title">
								<div class="label">3.</div>
								<div class="text">
									{{ 'App' | translate : { appName: displayValues.appName } }}
								</div>
							</div>
							<div class="section-subtitle">
								<div class="label">3.1.</div>
								<div class="text">
									{{
										'application_legal_terms_3_1'
											| translate : { appName: displayValues.appName }
											| uppercase
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.1.1.</div>
								<div class="text">
									{{
										'application_legal_terms_3_1_1'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.1.2.</div>
								<div class="text">
									{{
										'application_legal_terms_3_1_2'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.1.3.</div>
								<div class="text">
									{{
										'application_legal_terms_3_1_3'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.1.4.</div>
								<div class="text">
									{{
										'application_legal_terms_3_1_4'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.1.5.</div>
								<div class="text">
									{{
										'application_legal_terms_3_1_5'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.1.6.</div>
								<div class="text">
									{{
										'application_legal_terms_3_1_6'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-subtitle">
								<div class="label">3.2.</div>
								<div class="text">
									{{
										'application_legal_terms_3_2'
											| translate : { appName: displayValues.appName }
											| uppercase
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.2.1.</div>
								<div class="text">
									{{
										'application_legal_terms_3_2_1'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.2.2.</div>
								<div class="text" translate>application_legal_terms_3_2_2</div>
							</div>
							<div class="section-content">
								<div class="label">3.2.3.</div>
								<div class="text" translate>application_legal_terms_3_2_3</div>
							</div>
							<div class="section-content">
								<div class="label">3.2.4.</div>
								<div class="text">
									{{
										'application_legal_terms_3_2_4'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-subtitle">
								<div class="label">3.3.</div>
								<div class="text" translate>application_legal_terms_3_3</div>
							</div>
							<div class="section-content">
								<div class="label">3.3.1.</div>
								<div class="text">
									<span>
										{{
											'application_legal_terms_3_3_1'
												| translate : { appName: displayValues.appName }
										}}
									</span>
									<a
										><span (click)="scrollTo('support-endusers')" translate
											>chapter 5
										</span></a
									>.
								</div>
							</div>
							<div class="section-subtitle">
								<div class="label">3.4.</div>
								<div class="text">
									{{
										'application_legal_terms_3_4'
											| translate : { appName: displayValues.appName }
											| uppercase
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.4.1.</div>
								<div class="text">
									{{
										'application_legal_terms_3_4_1'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.4.2.</div>
								<div class="text">
									{{
										'application_legal_terms_3_4_2'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.4.3.</div>
								<div class="text">
									{{
										'application_legal_terms_3_4_3'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.4.3.1.</div>
								<div class="text" translate>
									application_legal_terms_3_4_3_1
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.4.3.2.</div>
								<div class="text" translate>
									application_legal_terms_3_4_3_2
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.4.3.3.</div>
								<div class="text">
									<span translate>application_legal_terms_3_4_3_3 </span>

									<table class="table-bordered privacy-cookies-table mt-1">
										<thead>
											<tr>
												<th translate>Cookie name</th>
												<th translate>Use</th>
												<th translate>Company</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>ai_session</td>
												<td translate>
													Preserves users states across page requests.
												</td>
												<td translate>Microsoft Corp</td>
											</tr>
											<tr>
												<td>ai_user</td>
												<td translate>
													Used by Microsoft Application Insights software to
													collect statistical usage and telemetry information.
													The cookie stores a unique identifier to recognise
													users on returning visits over time.
												</td>
												<td translate>Microsoft Corp</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<div class="section" id="application-support">
							<div class="section-title">
								<div class="label">4.</div>
								<div class="text" translate>Force majeure</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.</div>
								<div class="text">
									{{
										'application_legal_terms_4_1'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
						</div>
						<div class="section" id="support-endusers">
							<div class="section-title">
								<div class="label">5.</div>
								<div class="text" translate>User support</div>
							</div>
							<div class="section-subtitle">
								<div class="label">5.1.</div>
								<div class="text" translate>application_legal_terms_5_1</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.1</div>
								<div class="text">
									<span translate>application_legal_terms_5_1_1</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.2</div>
								<div class="text" translate>
									Working time of tehnical support
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.3.</div>
								<div class="text">
									{{
										'application_legal_terms_5_1_3'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.4</div>
								<div class="text">
									<span>
										{{
											'application_legal_terms_5_1_4'
												| translate : { appName: displayValues.appName }
										}}
									</span>
									<a
										class="ml-1"
										[externalRedirect]="
											EXTERNAL_PATH.MAIL_TO_PODPORA_SELTRON_HOME
										"
										>podpora@seltron.si</a
									>.
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.5</div>
								<div class="text" translate>application_legal_terms_5_1_5</div>
							</div>
						</div>
						<div class="section" id="providers-obligations">
							<div class="section-title">
								<div class="label">6.</div>
								<div class="text" translate>Provider's obligations</div>
							</div>
							<div class="section-content">
								<div class="label">6.1.</div>
								<div class="text">
									{{
										'application_legal_terms_6_1'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">6.2.</div>
								<div class="text">
									{{
										'application_legal_terms_6_2'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">6.3.</div>
								<div class="text">
									{{
										'application_legal_terms_6_3'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">6.4.</div>
								<div class="text">
									<span translate>application_legal_terms_6_4_1</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_PAGE"
										>www.seltronhome.si</a
									>
									ali
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_EU_HOME_PAGE"
										>www.seltronhome.eu</a
									>
									<span translate>application_legal_terms_6_4_2</span>
								</div>
							</div>
						</div>
						<div class="section" id="copyright-endusers">
							<div class="section-title">
								<div class="label">7.</div>
								<div class="text" translate>Copyright</div>
							</div>
							<div class="section-content">
								<div class="label">7.1.</div>
								<div class="text">
									{{
										'application_legal_terms_7_1'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">7.2.</div>
								<div class="text">
									{{
										'application_legal_terms_7_2'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
						</div>
						<div class="section" id="finalprovisions-endusers">
							<div class="section-title">
								<div class="label">8.</div>
								<div class="text" translate>Final provisions</div>
							</div>
							<div class="section-content">
								<div class="label">8.1.</div>
								<div class="text" translate>application_legal_terms_8_1</div>
							</div>
							<div class="section-content">
								<div class="label">8.2.</div>
								<div class="text" translate>application_legal_terms_8_2</div>
							</div>
							<div class="section-content">
								<div class="label">8.3.</div>
								<div class="text" translate>application_legal_terms_8_3</div>
							</div>
							<div class="section-content">
								<div class="label">8.4.</div>
								<div class="text">
									{{
										'application_legal_terms_8_4'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
							<div class="section-content">
								<div class="label">8.5.</div>
								<div class="text" translate>application_legal_terms_8_5</div>
							</div>
							<div class="section-content">
								<div class="label">8.6.</div>
								<div class="text">
									{{
										'application_legal_terms_8_6'
											| translate : { appName: displayValues.appName }
									}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="row"
					*ngIf="currentlegalPageState === LegalPageState.Privacy"
				>
					<div class="col col-12 col-md-4 menu">
						<ol>
							<li>
								<span (click)="scrollTo('general-privacy')" translate
									>General provisions</span
								>
							</li>
							<li>
								<span (click)="scrollTo('definitions-privacy')" translate
									>Definitions</span
								>
							</li>
							<li>
								<span (click)="scrollTo('legalbasis-privacy')" translate
									>Legal basis for collection, processing and storage of
									personal data</span
								>
							</li>
							<li>
								<span (click)="scrollTo('cookie-privacy')" translate
									>Data collected by SeltronHome web page and the purpose of
									processing</span
								>
							</li>
							<li>
								<span (click)="scrollTo('datacollection-privacy')" translate
									>Data collected by the Clausius application and the purpose of
									processing</span
								>
							</li>
							<li>
								<span (click)="scrollTo('clausiusaccount-privacy')" translate
									>Creating user account in Clausius application</span
								>
							</li>
							<li>
								<span (click)="scrollTo('datastorageperiod-privacy')" translate
									>Data storage period and termination of user account</span
								>
							</li>
							<li>
								<span
									(click)="scrollTo('dataanalysiscontractor-privacy')"
									translate
									>Contractual data processors</span
								>
							</li>
							<li>
								<span (click)="scrollTo('dataanalysiskelvin-privacy')" translate
									>Processing of data collected by the Kelvin application</span
								>
							</li>
							<li>
								<span
									(click)="scrollTo('employeeacquaintance-privacy')"
									translate
									>Informing employees about personal data protection</span
								>
							</li>
							<li>
								<span (click)="scrollTo('sharingdata-privacy')" translate
									>Disclosure of data to third persons</span
								>
							</li>
							<li>
								<span
									(click)="scrollTo('dataprivacyquestions-privacy')"
									translate
									>Inquiries on personal data protection</span
								>
							</li>
							<li>
								<span (click)="scrollTo('finalstatements-privacy')" translate
									>Final provisions</span
								>
							</li>
						</ol>
					</div>
					<div class="col col-12 col-md-8 legal-content">
						<div class="section" id="general-privacy">
							<div class="section-title">
								<div class="label">1.</div>
								<div class="text" translate>General provisions</div>
							</div>
							<div class="section-content">
								<div class="label">1.1.</div>
								<div class="text" translate>legal_privacy_1_1</div>
							</div>
							<div class="section-content">
								<div class="label">1.2.</div>
								<div class="text" translate>legal_privacy_1_2</div>
							</div>
							<div class="section-content">
								<div class="label">1.3.</div>
								<div class="text">
									<span translate>legal_privacy_1_3</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltronhome.com</a
									>.
								</div>
							</div>
							<div class="section-content">
								<div class="label">1.4.</div>
								<div class="text">
									<span translate>legal_privacy_1_4</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltronhome.com</a
									>.
								</div>
							</div>
						</div>
						<div class="section" id="definitions-privacy">
							<div class="section-title">
								<div class="label">2.</div>
								<div class="text" translate>Definitions</div>
							</div>
							<div class="section-text">
								<div class="label">&nbsp;</div>
								<div class="text" translate>
									In this statement, the terms used shall have the following
									meanings:
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.1.</div>
								<div class="text">
									<b translate>legal_privacy_2_1_1</b>
									<span class="ml-1" translate>legal_privacy_2_1_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.2.</div>
								<div class="text">
									<b translate>legal_privacy_2_2_1</b>
									<span class="ml-1" translate>legal_privacy_2_2_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.3.</div>
								<div class="text">
									<b translate>legal_privacy_2_3_1</b>
									<span class="ml-1" translate>legal_privacy_2_3_2</span>
									<ng-container *ngIf="languageName === 'en'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
											>www.seltronhome.com</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.4.</div>
								<div class="text">
									<b translate>legal_privacy_2_4_1</b>
									<span class="ml-1" translate>legal_privacy_2_4_2</span>
									<ng-container *ngIf="languageName === 'sl'">
										<a
											class="ml-1"
											[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
											>www.seltronhome.com</a
										>.
									</ng-container>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.5.</div>
								<div class="text">
									<b translate>legal_privacy_2_5_1</b>
									<span class="ml-1" translate>legal_privacy_2_5_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.6.</div>
								<div class="text">
									<b translate>legal_privacy_2_6_1</b>
									<span class="ml-1" translate>legal_privacy_2_6_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">2.7.</div>
								<div class="text">
									<b translate>legal_privacy_2_7_1</b>
									<span class="ml-1" translate>legal_privacy_2_7_2</span>
								</div>
							</div>
						</div>
						<div class="section" id="legalbasis-privacy">
							<div class="section-title">
								<div class="label">3.</div>
								<div class="text" translate>
									Legal basis for collection, processing and storage of personal
									data
								</div>
							</div>
							<div class="section-content">
								<div class="label">3.1.</div>
								<div class="text" translate>legal_privacy_3_1</div>
							</div>
							<div class="section-content">
								<div class="label">3.2.</div>
								<div class="text" translate>legal_privacy_3_2</div>
							</div>
						</div>
						<div class="section" id="cookie-privacy">
							<div class="section-title">
								<div class="label">4.</div>
								<div class="text" translate>
									Data collected by SeltronHome web page and the purpose of
									processing
								</div>
							</div>
							<div class="section-text">
								<div class="label">&nbsp;</div>
								<div class="text">
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltronhome.com</a
									>
									<span translate>
										website collects information on how you use the website.
										Information is stored into small text documents known as
										cookies.</span
									>
								</div>
							</div>
							<div class="section-content">
								<div class="label">4.1.</div>
								<div class="text">
									<span translate>what_are_cookies</span>
									<span class="d-block" translate>legal_privacy_4_1</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">4.2.</div>
								<div class="text">
									<span translate>whay_we_use_cookies</span>
									<span class="d-block" translate>legal_privacy_4_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">4.3.</div>
								<div class="text">
									<span translate>list_of_cookies</span>

									<table class="table-bordered privacy-cookies-table mt-1">
										<thead>
											<tr>
												<th translate>Cookie name</th>
												<th translate>Use</th>
												<th translate>Company</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>ai_session</td>
												<td translate>
													Preserves users states across page requests.
												</td>
												<td translate>Microsoft Corp</td>
											</tr>
											<tr>
												<td>ai_user</td>
												<td translate>
													Used by Microsoft Application Insights software to
													collect statistical usage and telemetry information.
													The cookie stores a unique identifier to recognise
													users on returning visits over time.
												</td>
												<td translate>Microsoft Corp</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>

						<div class="section" id="datacollection-privacy">
							<div class="section-title">
								<div class="label">5.</div>
								<div class="text" translate>
									Data collected by the Clausius application and the purpose of
									processing
								</div>
							</div>
							<div class="section-text">
								<div class="label">&nbsp;</div>
								<div class="text" translate>
									The following user data is collected and processed:
								</div>
							</div>
							<div class="section-subtitle">
								<div class="label">5.1.</div>
								<div class="text" translate>Personal data of users</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.1.</div>
								<div class="text">
									<span class="d-block" translate>legal_privacy_5_1_1_1</span>
									<span translate>legal_privacy_5_1_1_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.2.</div>
								<div class="text">
									<span class="d-block" translate>legal_privacy_5_1_2_1</span>
									<span translate>legal_privacy_5_1_2_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.3.</div>
								<div class="text">
									<span class="d-block" translate>legal_privacy_5_1_3_1</span>
									<span translate>legal_privacy_5_1_3_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.4.</div>
								<div class="text">
									<span class="d-block" translate>legal_privacy_5_1_4_1</span>
									<span translate>legal_privacy_5_1_4_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.5.</div>
								<div class="text">
									<span class="d-block" translate>legal_privacy_5_1_5_1</span>
									<span translate>legal_privacy_5_1_5_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.6.</div>
								<div class="text">
									<span class="d-block" translate>legal_privacy_5_1_6_1</span>
									<span translate>legal_privacy_5_1_6_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.1.7.</div>
								<div class="text">
									<span class="d-block" translate>legal_privacy_5_1_7_1</span>
									<span translate>legal_privacy_5_1_7_2</span>
								</div>
							</div>
							<div class="section-subtitle">
								<div class="label">5.2.</div>
								<div class="text" translate>Device data</div>
							</div>
							<div class="section-content">
								<div class="label">5.2.1.</div>
								<div class="text">
									<span class="d-block" translate>legal_privacy_5_2_1_1</span>
									<span translate>legal_privacy_5_2_1_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.2.2.</div>
								<div class="text">
									<span class="d-block" translate>legal_privacy_5_2_2_1</span>
									<span translate>legal_privacy_5_2_2_2</span>
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.2.3.</div>
								<div class="text">
									<span class="d-block" translate>legal_privacy_5_2_3_1</span>
									<span translate>legal_privacy_5_2_3_2</span>
									<ul>
										<li translate>legal_privacy_5_2_3_3</li>
										<li translate>legal_privacy_5_2_3_4</li>
									</ul>
								</div>
							</div>
							<div class="section-content">
								<div class="label">5.2.4.</div>
								<div class="text" translate>legal_privacy_5_2_4</div>
							</div>
						</div>
						<div class="section" id="clausiusaccount-privacy">
							<div class="section-title">
								<div class="label">6.</div>
								<div class="text" translate>
									Creating user account in Clausius application
								</div>
							</div>
							<div class="section-content">
								<div class="label">6.1.</div>
								<div class="text">
									<span translate>legal_privacy_6_1</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltronhome.com</a
									>.
								</div>
							</div>
							<div class="section-content">
								<div class="label">6.2.</div>
								<div class="text" translate>legal_privacy_6_2</div>
							</div>
							<div class="section-content">
								<div class="label">6.3.</div>
								<div class="text">
									<span translate>legal_privacy_6_3</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.AUTH_0_SECURITY"
										>https://auth0.com/security</a
									>.
								</div>
							</div>
							<div class="section-content">
								<div class="label">6.4.</div>
								<div class="text" translate>legal_privacy_6_4</div>
							</div>
						</div>
						<div class="section" id="datastorageperiod-privacy">
							<div class="section-title">
								<div class="label">7.</div>
								<div class="text" translate>
									Data storage period and termination of user account
								</div>
							</div>
							<div class="section-content">
								<div class="label">7.1.</div>
								<div class="text" translate>legal_privacy_7_1</div>
							</div>
							<div class="section-content">
								<div class="label">7.2.</div>
								<div class="text" translate>legal_privacy_7_2</div>
							</div>
							<div class="section-content">
								<div class="label">7.3.</div>
								<div class="text" translate>legal_privacy_7_3</div>
							</div>
						</div>
						<div class="section" id="dataanalysiscontractor-privacy">
							<div class="section-title">
								<div class="label">8.</div>
								<div class="text" translate>Contractual data processors</div>
							</div>
							<div class="section-content">
								<div class="label">8.1.</div>
								<div class="text" translate>legal_privacy_8_1</div>
							</div>
							<div class="section-content">
								<div class="label">8.2.</div>
								<div class="text" translate>legal_privacy_8_2</div>
							</div>
							<div class="section-content">
								<div class="label">8.3.</div>
								<div class="text">
									<span translate>legal_privacy_8_3_1</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.MAIL_TO_INFO_SELTRON_HOME"
										>info@seltronhome.com</a
									>
									<span class="ml-1" translate>legal_privacy_8_3_2</span>
								</div>
							</div>
						</div>
						<div class="section" id="dataanalysiskelvin-privacy">
							<div class="section-title">
								<div class="label">9.</div>
								<div class="text" translate>
									Processing of data collected by the Kelvin application
								</div>
							</div>
							<div class="section-content">
								<div class="label">9.1.</div>
								<div class="text" translate>legal_privacy_9_1</div>
							</div>
							<div class="section-content">
								<div class="label">9.2.</div>
								<div class="text" translate>legal_privacy_9_2</div>
							</div>
							<div class="section-content">
								<div class="label">9.3.</div>
								<div class="text" translate>legal_privacy_9_3</div>
							</div>
							<div class="section-content">
								<div class="label">9.4.</div>
								<div class="text">
									<div class="text" translate>legal_privacy_9_4</div>
									<ul>
										<li translate>legal_privacy_9_4_1</li>
										<li translate>legal_privacy_9_4_2</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="section" id="dataanalysisclausiusbt-privacy">
							<div class="section-title">
								<div class="label">10.</div>
								<div class="text" translate>
									Processing of data collected by the Clausisus BT application
								</div>
							</div>
							<div class="section-content">
								<div class="label">10.1.</div>
								<div class="text" translate>legal_privacy_10_1</div>
							</div>
							<div class="section-content">
								<div class="label">10.2.</div>
								<div class="text" translate>legal_privacy_10_2</div>
							</div>
							<div class="section-content">
								<div class="label">10.3.</div>
								<div class="text" translate>legal_privacy_10_3</div>
							</div>
							<div class="section-content">
								<div class="label">10.4.</div>
								<div class="text" translate>legal_privacy_10_4</div>
							</div>
							<div class="section-content">
								<div class="label">10.5.</div>
								<div class="text" translate>legal_privacy_10_5</div>
							</div>
							<div class="section-content">
								<div class="label">10.6.</div>
								<div class="text" translate>legal_privacy_10_6</div>
							</div>
						</div>
						<div class="section" id="employeeacquaintance-privacy">
							<div class="section-title">
								<div class="label">11.</div>
								<div class="text" translate>
									Informing employees about personal data protection
								</div>
							</div>
							<div class="section-content">
								<div class="label">11.1.</div>
								<div class="text" translate>legal_privacy_11_1</div>
							</div>
						</div>
						<div class="section" id="sharingdata-privacy">
							<div class="section-title">
								<div class="label">12.</div>
								<div class="text" translate>
									Disclosure of data to third persons
								</div>
							</div>
							<div class="section-content">
								<div class="label">12.1.</div>
								<div class="text" translate>legal_privacy_12_1</div>
							</div>
							<div class="section-content">
								<div class="label">12.2.</div>
								<div class="text" translate>legal_privacy_12_2</div>
							</div>
						</div>
						<div class="section" id="dataprivacyquestions-privacy">
							<div class="section-title">
								<div class="label">13.</div>
								<div class="text" translate>
									Inquiries on personal data protection
								</div>
							</div>
							<div class="section-content">
								<div class="label">13.1.</div>
								<div class="text">
									<span translate>legal_privacy_13_1</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.MAIL_TO_INFO_SELTRON_HOME"
										>info@seltronhome.com</a
									>.
								</div>
							</div>
							<div class="section-content">
								<div class="label">13.2.</div>
								<div class="text">
									<span translate>legal_privacy_13_2_1</span>
									<a
										class="ml-1"
										[externalRedirect]="EXTERNAL_PATH.SELTRON_HOME_COM"
										>www.seltronhome.com</a
									>
									<span class="ml-1" translate>legal_privacy_13_2_2</span>
								</div>
							</div>
						</div>
						<div class="section" id="finalstatements-privacy">
							<div class="section-title">
								<div class="label">14.</div>
								<div class="text" translate>Final provisions</div>
							</div>
							<div class="section-content">
								<div class="label">14.1.</div>
								<div class="text" translate>legal_privacy_14_1</div>
							</div>
							<div class="section-content">
								<div class="label">14.2.</div>
								<div class="text" translate>legal_privacy_14_2</div>
							</div>
							<div class="section-content">
								<div class="label">14.3.</div>
								<div class="text" translate>legal_privacy_14_3</div>
							</div>
							<div class="section-content">
								<div class="label">14.4.</div>
								<div class="text" translate>legal_privacy_14_4</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</app-page>
</ng-container>
